import { render, staticRenderFns } from "./scene8.vue?vue&type=template&id=87fbfb9e&scoped=true&"
import script from "./scene8.vue?vue&type=script&lang=ts&"
export * from "./scene8.vue?vue&type=script&lang=ts&"
import style0 from "./scene8.vue?vue&type=style&index=0&id=87fbfb9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fbfb9e",
  null
  
)

export default component.exports